import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { editAnswerKeyRequest } from '../requests/editAnswerKeyRequest';
import { AnswerKeyFormRequestProps } from '../types/template.type';
import { Alert } from '../../../components/Alert';
import { queryClient } from '../../../app/App';
import { AxiosError } from 'axios';

export function useEditAnswerKey() {
	const navigate = useNavigate();

	const editAnswerKey = useMutation({
		mutationFn: async (data: AnswerKeyFormRequestProps[]) => {
			return editAnswerKeyRequest(data);
		},
		onSuccess: () => {
			Alert({ message: 'Successfully edited!', type: 'success' });
			queryClient.invalidateQueries(['TEMPLATE_LIST']);
			navigate(-1);
		},
		onError: (error: AxiosError) => {
			Alert({ message: error.message, type: 'error' });
		},
	});

	return { editAnswerKey };
}
